export default __webpack_public_path__ + "static/media/climb-scene.1e30c51c.svg";